export * from "./inquiries-table";
